import withSearch from '../hoc/withSearch';
import PreviewCardContainer from '../components/PreviewCardContainer';

const PreviewCardContainerWithSearch = withSearch(PreviewCardContainer);

export default PreviewCardContainerWithSearch;
